export function exponentialBackoff(
  minDelay: number,
  maxDelay: number
): (attempt: number) => number {
  return (attempt: number) => Math.min(attempt > 1 ? 2 ** attempt * minDelay : minDelay, maxDelay);
}

export function linearBackoff(
  step: number,
  minDelay: number,
  maxDelay: number
): (attempt: number) => number {
  return (attempt: number) => Math.min(attempt * step + minDelay, maxDelay);
}
